<template>
    <div>
        <base-header type="primary" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>

        <div class="container-fluid pt-4">
            <div class="row">
                <div class="col-12 mb-4">
                    <router-link :to="{ name: 'company data' }" class=" btn btn-sm btn-primary">+ Add new company</router-link>
                </div>
                <b-table
                        :items="list"
                        :fields="tableFields"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        responsive
                        fixed
                        striped
                        show-empty
                        >
                        <template #cell(title)="data">
                            <router-link
                                :to="{ name: 'company data', params: { id: data.item.id } }"
                                class="text-primary font-weight-bold text-uppercase">
                                {{data.item.data.title}}
                            </router-link>
                        </template>
                        <template #cell(actions)="data">
                            <router-link
                                            :to="{ name: 'company data', params: { id: data.item.id } }"
                                            class=" btn btn-sm btn-primary btn-icon-only rounded-circle mt-1">
                                <i class="fa fa-eye"></i>
                            </router-link>
                            <button @click="deleteForm(data.item.id)" type="button"
                                    class=" btn btn-sm btn-danger btn-icon-only rounded-circle mt-1">
                                <i class="fa fa-trash"></i>
                            </button>
                        </template>
                </b-table>
            </div>
        </div>

    </div>
</template>

<script>

    window.$ = window.jQuery = require('jquery');
    import firebase from '../config/db.js';
    import moment from 'moment'
    import swal from 'sweetalert2'
    import Vue from "vue";
    import { TablePlugin } from 'bootstrap-vue'
    Vue.use(TablePlugin)

    export default {
        name: 'insurance-companies',
        data() {
            return {
                list: [],
                publicPath: process.env.BASE_URL,
                tableFields: [
                    { key: 'title', sortable: true },
                    { key: 'actions', sortable: false }
                ],
                sortBy: 'title',
                sortDesc: false,
            }
        },
        mounted: function () {
            this.getFormList();
        },
        methods: {
            getFormList: function () {
                var collection = [];
                firebase.firestore().collection("companies").orderBy("title", 'desc').get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        collection.push({
                            id:doc.id,
                            title: doc.data().title,
                            data: doc.data(),
                        });
                    });
                });
                this.list = collection;
            },
            deleteForm: function (data_key) {
                var that = this;

                swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    type: "warning",
                    showCancelButton: !0,
                    icon: 'warning',
                    confirmButtonColor: "#0CC27E",
                    cancelButtonColor: "#FF586B",
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, cancel!",
                    confirmButtonClass: "btn btn-success mr-5",
                    cancelButtonClass: "btn btn-danger",
                    buttonsStyling: !1
                }).then((result) => {
                    if (result.value) {
                        firebase.firestore().collection("companies").doc(data_key).delete().then(function() {
                            swal.fire({
                                text: "Company deleted successfully...",
                                type: "success",
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 1500
                            });
                            that.getFormList();
                        }).catch(function(error) {
                            swal({
                                text: error,
                                type: "error",
                                showConfirmButton: false,
                                timer: 1500
                            });
                        });
                    }
                });
            }
        },
        filters: {
            readableDate: function (value) {
                if (!value || typeof value === 'undefined'){
                    return '';
                }else if(value instanceof Date){
                    return moment( value ).format('MMMM Do YYYY, h:mm:ss A');
                }
                return '';
            }
        }

    };
</script>

